import { TableRow, TableCell, Box, TextInput, Button, Text, Keyboard } from "grommet"
import { Add, Trash } from "grommet-icons"
import { forwardRef, memo, useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { deleteLot, updateLot } from "../../slices/auctionDataSlice"
import "./AuctionTableRow.css"
import { FirstMedal } from "../../icons/FirstMedal"
import { SecondMedal } from "../../icons/SecondMedal"
import { ThirdMedal } from "../../icons/ThirdMedal"

const topRowsClasses = ['top-1-row', 'top-2-row', 'top-3-row']

const topRowsIcons = [<FirstMedal color="#eab308" />, <SecondMedal color="#9ca3af" />, <ThirdMedal color="#f97316" />]

export const AuctionTableRow = memo(forwardRef(({ dataRow, index, ...props }, ref) => {

    const dispatch = useDispatch();

    const [cost, setCost] = useState(dataRow.extraCost);
    const [editedName, setEditedName] = useState(dataRow.lotName);
    const [editedTotalCost, setEditedTotalCost] = useState(dataRow.cost);

    useEffect(() => {
        setEditedName(dataRow.lotName);
    }, [dataRow.lotName]);

    useEffect(() => {
        setEditedTotalCost(dataRow.cost);
    }, [dataRow.cost]);

    const onNameEditComplete = () => {
        if (editedName.trim().length > 0 && editedName !== dataRow.lotName) {
            dispatch(updateLot({ ...dataRow, index, lotName: editedName.trim(), extraCost: 0 }));
        } else {
            setEditedName(dataRow.lotName);
        }
    }

    const onCostEditComplete = () => {
        const newCost = Number(editedTotalCost);
        if (!isNaN(newCost) && newCost !== dataRow.cost) {
            const difference = newCost - dataRow.cost;
            dispatch(updateLot({ ...dataRow, index, extraCost: difference }));
        } else {
            setEditedTotalCost(dataRow.cost);
        }
    }

    const onLotAdd = () => {
        let lot = {
            id: dataRow.id,
            lotName: dataRow.lotName,
            cost: dataRow.cost
        }
        if (cost && cost.length > 0) {
            dispatch(updateLot({ ...lot, ...{ index, extraCost: Number(cost) } }));
            setCost('');
        }
    }

    const onLotDelete = () => {
        dispatch(deleteLot({ ...dataRow, ...{ index } }));
    }

    return (
        <TableRow key={dataRow.id} ref={ref} {...props} className={`${props.className || ''} ${topRowsClasses[index]}`.trim()}>
            <TableCell scope="row">{topRowsIcons[index] || (<Text>{`${index + 1}.`}</Text>)}</TableCell>
            <TableCell size="xsmall" scope="row">{dataRow.id}</TableCell>
            <TableCell size="small" scope="row">
                <Keyboard onEnter={onNameEditComplete}>
                    <TextInput
                        value={editedName}
                        onChange={(event) => setEditedName(event.target.value)}
                        onBlur={onNameEditComplete}
                        plain
                        className="editable-lot-name"
                    />
                </Keyboard>
            </TableCell>
            <TableCell scope="row">{Number(dataRow.chance * 100).toFixed(2)}%</TableCell>
            <TableCell scope="row">
                <Box direction="row" gap="xsmall" key={dataRow.id} align="center">
                    {/* <TextInput placeholder="UAH" value={dataRow.cost} /> */}
                    <Box basis="1/2">
                        <Keyboard onEnter={onCostEditComplete}>
                            <TextInput
                                type="number"
                                value={editedTotalCost}
                                onChange={(event) => setEditedTotalCost(event.target.value)}
                                onBlur={onCostEditComplete}
                                plain
                                className="editable-lot-name"
                                icon={<Text weight="bold">₴</Text>}
                                reverse
                            />
                        </Keyboard>
                    </Box>
                    <Box basis="1/2">
                        <Keyboard onEnter={onLotAdd}>
                            <TextInput type="number" placeholder="₴" value={cost} onChange={(event) => setCost(event.target.value)} />
                        </Keyboard>
                    </Box>
                </Box>
            </TableCell>
            <TableCell scope="row" className="table-cell-with-btns" hoverIndicator={false}>
                <Box direction="row" gap="xsmall" hoverIndicator={false}>
                    <Button className="auction-add-btn" plain icon={<Add />} onClick={onLotAdd} hoverIndicator={false} />
                    <Button className="auction-delete-btn" plain icon={<Trash />} onClick={onLotDelete} hoverIndicator={false} />
                </Box>
            </TableCell>
        </TableRow>
    )
}))